












































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { ActiveBotLicenseSteps, FlowTemplate, FlowTemplateNames } from '../types'

@Component({
})
export default class SelectTemplateStep extends Vue {
  @Prop({ type: Boolean, default: true }) showHint!: boolean

  @Prop({ type: String, default: null }) hint!: string | null

  @Prop({ type: Boolean, default: true }) showFooter!: boolean

  @Emit()
  selectTemplate(template: FlowTemplate) {
    return template
  }

  @Emit()
  complete():ActiveBotLicenseSteps {
    return ActiveBotLicenseSteps.SelectTemplate
  }

  get stepHint() {
    if (this.hint) {
      return this.hint
    } else {
      return this.$t('test_period_prime_templates_about').toString()
    }
  }

  flowTemplates: Array<FlowTemplate> = this.defaultTemplates()

  imageAlt(template: FlowTemplateNames) {
    const ftKey = snakeCase(template)

    return this.$te(`flow_${ ftKey }_title`) ? this.$t(`flow_${ ftKey }_title`).toString() : template
  }

  defaultTemplates(): Array<FlowTemplate> {
    return [
      {
        config: {
          template: FlowTemplateNames.PaidSubscription,
          title: "",
          data: { channel: null },
        },
        about: {
          description: this.$t('flow_template_paid_subscription_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/paid_subscription.png",
          video: "https://cdn.presscode.app/flow-templates/video/paid_subscription.m4v",
        },
      },
      {
        config: {
          template: FlowTemplateNames.SuggestContent,
          title: ""
        },
        about: {
          description:this.$t('flow_template_suggest_content_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/suggest_content.png",
          video: "https://cdn.presscode.app/flow-templates/video/suggest_content.m4v",
        }
      },
      {
        config: {
          template: FlowTemplateNames.QuestionnaireSubscription,
          title: "",
          data: { channel: null },
        },
        about: {
          description: this.$t('flow_template_questionnaire_subscription_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/questionnaire_subscription.png",
          video: "https://cdn.presscode.app/flow-templates/video/questionnaire_subscription.m4v",
        }
      },
      {
        config: {
          template: FlowTemplateNames.HotSale,
          title: "",
        },
        about: {
          description: this.$t('flow_template_hot_sale_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/hot_sale.png",
          video: "https://cdn.presscode.app/flow-templates/video/hot_sale.m4v",
        },
      },
      {
        config: {
          template: FlowTemplateNames.Marathon,
          title: "",
        },
        about: {
          description: this.$t('flow_template_marathon_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/marathon.png",
          video: "https://cdn.presscode.app/flow-templates/video/marathon.m4v",
        }
      },
      {
        config: {
          template: FlowTemplateNames.WineCatalog,
          title: "",
        },
        about: {
          description: this.$t('flow_template_wine_catalog_description').toString(),
          image: "https://cdn.presscode.app/flow-templates/img/wine_catalog.png",
          video: "https://cdn.presscode.app/flow-templates/video/wine_catalog.m4v",
        }
      },
    ]
  }

}
